import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out
 * of the slice's reducers: they trigger side effects, not state transitions (the
 * saga owns the resulting `load*` / `save*` transitions).
 */

/** Load the user by id (dispatched on mount). */
export const loadRequested = createAction<string>('editUser/loadRequested');

/** Persist the current draft (dispatched on Save). */
export const submitRequested = createAction('editUser/submitRequested');
